import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { useLocalStore } from "mobx-react";
import React from 'react';
import { AdminViewModel, AdminViewModelInstance } from "./AdminViewModel";
import { events, EventsChannel } from 'aws-amplify/api';

declare global {
  interface Window { API_ENDPOINT: string; }
}

const httpLink = createUploadLink({
  uri: window._env_.API_ENDPOINT,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache()
})

const authToken = window._env_.RTC_TOKEN;
let sessionChannel: EventsChannel;

const getSessionChannel = async () => {
  if (!sessionChannel) {
    sessionChannel = await events.connect('/application/session', { authToken });
  }
  return sessionChannel;
}

const storeContext = React.createContext<AdminViewModelInstance | null>(null);

const createStore = () =>
  AdminViewModel.create({}, {
    client,
    getSessionChannel,
  });

export const StoreProvider: React.SFC = ({ children }) => {
  const store = useLocalStore(createStore);
  return <storeContext.Provider value={store}>{children}</storeContext.Provider>
}

export const useStore = () => {
  const store = React.useContext(storeContext);
  if (!store) { throw new Error(`useStore must be used within a StoreProvider`) }
  else return store;
}
